import s from "./CdrLabelWrapper.vue2.mjs";
import o from "./styles/CdrLabelWrapper.module.scss.mjs";
import r from "../../_virtual/_plugin-vue_export-helper.mjs";
const t = {
  $style: o
}, c = /* @__PURE__ */ r(s, [["__cssModules", t]]);
export {
  c as default
};
